import Header from "../../Header"
import Movies from "./Movies"

export default function HomeScreen() {
    return (
        <>
            <Header headerText='Selecione o filme' />
            <Movies />
        </>
    )
};